import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBook2Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18 2C19.1046 2 20 2.89543 20 4V16.99C20 17.1576 19.9623 17.3115 19.8872 17.4617L19.3416 18.5528C19.2009 18.8343 19.2009 19.1657 19.3416 19.4472L19.8854 20.5348C19.9586 20.6737 20 20.832 20 21C20 21.5523 19.5523 22 19 22H7C5.34315 22 4 20.6569 4 19V5C4 3.34315 5.34315 2 7 2H18ZM17.4076 18H7C6.44772 18 6 18.4477 6 19C6 19.5128 6.38604 19.9355 6.88338 19.9933L7 20H17.4076C17.2043 19.4251 17.1817 18.803 17.3398 18.2176L17.4076 18ZM18 4H7C6.48717 4 6.06449 4.38604 6.00673 4.88338L6 5V16.1707C6.25022 16.0823 6.51568 16.0261 6.79138 16.0071L7 16H18V4ZM14 7C14.5523 7 15 7.44772 15 8C15 8.51283 14.614 8.93551 14.1166 8.99327L14 9H10C9.44772 9 9 8.55228 9 8C9 7.48717 9.38604 7.06449 9.88338 7.00673L10 7H14Z",
		fill: "currentColor"
	})
});
export default SvgBook2Line;
